import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/tickets/$ticketId` activates the ticket-thread column
// (col 2). The Tickets LAYOUT route (tickets.tsx) reads `$ticketId` from the
// leaf match and renders every column via ColumnLayout. Mirrors forms/$formId.
export const Route = createFileRoute("/$orgSlug/$eventSlug/tickets/$ticketId")({
  component: () => null,
})
